import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyAglMMzFRT3XfiQKqnCOkmXmTQJlW2wK5g',
  authDomain: 'harlan-a8709.firebaseapp.com',
  projectId: 'harlan-a8709',
  storageBucket: 'harlan-a8709.firebasestorage.app',
  messagingSenderId: '1021937885435',
  appId: '1:1021937885435:web:c94b65504cca967976105e',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
